<template>
  <ion-page>
    <Background></Background>
    <WhiteBackground></WhiteBackground>
    <FabColumn>
      <QuitButton content_1="您所輸入的資料將不會被保留。" content_2="是否確認退出帳戶註冊？"></QuitButton>
      <BackButton :back_url="back_url"></BackButton>
    </FabColumn>

    <ion-content>
      <MainTitle text="設定密碼"></MainTitle>
      <InputBox text="手提電話號碼" :value="showMobile" hideInput="true"></InputBox>
      <InputBox text="用戶名稱" :value="name" hideInput="true"></InputBox>
      <InputBox text="密碼" placeholder="6-18位英文或數字或符號" type="password" @getValue="getPasswordValue"></InputBox>
      <InputBox text="確認密碼" placeholder="請再次輸入密碼" type="password" @getValue="getConfirmPasswordValue"></InputBox>
      <ConfirmButton text="註冊" position="relative" @click="setPassword"></ConfirmButton>
    </ion-content>
  </ion-page>
</template>

<script>
import {IonContent, IonPage} from "@ionic/vue";
import Background from "../components/common/Background";
import WhiteBackground from "../components/common/WhiteBackground";
import MainTitle from "../components/common/MainTitle";
import common from "../common";
import ConfirmButton from "../components/common/ConfirmButton";
import QuitButton from "../components/common/QuitButton";
import BackButton from "../components/common/BackButton";
import router from "../router";
import InputBox from "../components/common/InputBox";

export default {
  name: "SetPasswordByName",
  components: {
    InputBox,
    BackButton,
    QuitButton,
    ConfirmButton,
    MainTitle,
    WhiteBackground,
    Background,
    IonPage,
    IonContent,
  },
  data() {
    return {
      mobile: '',
      showMobile: '',
      name: '',
      password: '',
      confirmPassword: '',
      back_url: '',
    }
  },
  mounted() {
    this.mobile = this.$route.params.mobile;
    this.showMobile = common.splitMobile(this.mobile)
    this.name = this.$route.params.name;
    this.back_url = 'registerName/'+this.mobile
  },
  methods: {
    getPasswordValue: function (value) {
      this.password = value;
    },
    getConfirmPasswordValue: function (value) {
      this.confirmPassword = value;
    },
    setPassword: function () {
      if (this.password.trim().length === 0) {
        common.showAlert('請輸入密碼。')
        return false;
      }
      if (this.confirmPassword.trim().length === 0) {
        common.showAlert('請確認密碼。')
        return false;
      }
      if (this.password !== this.confirmPassword) {
        common.showAlert('密碼不一致，請重新輸入。')
        return false;
      }

      const loading = common.showLoading();
      common.apiPostData('/setPasswordByName', {mobile: this.mobile, name: this.name, password: this.password, confirm_password: this.confirmPassword}, false, loading).then(res => {
        if (res === false) {
          return false;
        }

        router.replace('/login')
      })
    }
  }
}
</script>

<style scoped>

</style>
